import {SECURE_HEADER_QUERY_STRING} from "../../config/constants"

const isSecurePageRequested = (url: string): boolean => {
    const trimmedUrl = (url && (url[0] === "/" ? url.substring(1) : url)) || ""
    return (new URLSearchParams(trimmedUrl).get(SECURE_HEADER_QUERY_STRING)?.toLocaleLowerCase() || "") === "true"
}

export default isSecurePageRequested
